import componentsOverrides from 'src/configs/styles/overrides'

import { ThemeType } from '../ui.types'

export const benestreamColors = {
  primary: [
    '#87A099',
    '#7E968F',
    '#768D85',
    '#0F4033',
    '#657971',
    '#5F8077',
    '#52705D',
    '#456254',
    '#37544A',
    '#0D352B',
  ],
  secondary: [
    '#F4B9A6',
    '#F2B09B',
    '#F0A790',
    '#EE9E85',
    '#EC957A',
    '#ED8A6A',
    '#EB805E',
    '#E9724C',
    '#D56647',
    '#C25F3F',
  ],
  red: [
    '#FFF5F5',
    '#FFE3E3',
    '#FFC9C9',
    '#FFA8A8',
    '#FF8787',
    '#FF6B6B',
    '#FA5252',
    '#F03E3E',
    '#E53E3E',
    '#C92A2A',
  ],
  gray: [
    '#FCFDFF',
    '#F4F4F4',
    '#E6E8EC',
    '#A3AAB8',
    '#C3CBDD',
    '#8A909E',
    '#BBC2D3',
    '#A3AAB8',
    '#444955',
    '#21252C',
    '#EAECF0',
  ],
  neutral: [
    '#FCFCFF',
    '#EDF0F5',
    '#DFE3EB',
    '#D1D7E1',
    '#C3CBDD',
    '#AEB8C9',
    '#9AA5B5',
    '#8A909E',
    '#666666',
    '#444955',
  ],
}

export const benestreamCssVariables = {
  'black-color': '#000000',
  'white-color': '#FFFFFF',
  'blue-50-color': '#0f4033',
  'gray-20-color': '#b4b9c4',

  'primary-40-color': '#0D352B',
  'primary-30-color': '#0F4033',
  'primary-20-color': '#376055',
  'primary-10-color': '#5F8077',
  'primary-00-color': '#87A099',

  'secondary-40-color': '#C25F3F',
  'secondary-30-color': '#E9724C',
  'secondary-20-color': '#ED8A6A',
  'secondary-10-color': '#F0A188',
  'secondary-00-color': '#F4B9A6',

  'red-50-color': '#E53E3E',

  'neutral-40-color': '#444955',
  'neutral-30-color': '#666666',
  'neutral-20-color': '#8A909E',
  'neutral-10-color': '#C3CBDD',
  'neutral-00-color': '#FCFCFF',

  'background-primary-color': '#F2F3F3',
  'background-secondary-color': '#D6F5ED',

  'status-blue-background-color': 'rgba(212, 219, 255, 0.7)',
  'status-red-background-color': '#ebb9b9',
  'status-gray-color': '#C3CBDD',
  'status-orange-color': '#F7B055',
  'status-red-color': '#E34A30',
  'status-green-color': '#1DC39A',
  'status-blue-color': '#63b9ff',

  'neutral-10-color-opacity': 'rgba(195, 203, 221, 0.3)',
  'primary-00-color-opacity': 'rgba(135, 160, 153, 0.3)',
  'secondary-00-color-opacity': 'rgba(244, 185, 166, 0.3)',
  'red-00-color-opacity': 'rgba(235, 185, 185, 0.3)',

  'body-color': 'var(--neutral-40-color)',
  'button-border-radius': '8px',
  'input-border-radius': '8px',
  'input-border-width': '2px',
}

export const benestreamMantineConfig = {
  primaryColor: 'primary',
  primaryShade: { light: 3, dark: 7 },
  fontFamily: '"SFProText", sans-serif',
  white: '#FFFFFF',
  black: '#000000',
  headings: {
    fontFamily: '"SFProText", sans-serif',
  },
}

export const benestreamThemeConfig = {
  name: ThemeType.BENESTREAM,
  type: 'benestream',
  version: '1.0.0',
  colors: benestreamColors,
  cssVariables: benestreamCssVariables,
  components: { ...componentsOverrides },
  mantineConfig: benestreamMantineConfig,
}
